import { inject, injectable, injectFromBase } from 'inversify';
import { AbstractCockpitApiService } from '@shared/common/network/data/service/abstract-cockpit.api-service';
import { HostDependencyTypes } from '@shared/common/host/host.dependency-types';

@injectable()
@injectFromBase()
export class HubApiService extends AbstractCockpitApiService {
  constructor(@inject(HostDependencyTypes.HubHost) baseUrl: string) {
    super(baseUrl);
  }
}
